<template>
  <div class="recruitment-recap">
    <!-- Qualification -->
    <IconLabel
      heavy
      :label="NovicesPrecision"
      icon="icon-f-search"
      icon-size="23px"
    />
    <!-- Details -->
    <IconLabel
      heavy
      :label="$t('ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@DETAILS')"
      icon="icon-f-file-text"
      icon-size="23px"
    />

    <p class="recruitement-location">
      {{ missionAddressDisplay }}
    </p>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <article class="recruitment-precisions" v-html="precisionsText" />
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      default: () => "",
    },
    precision: {
      type: String,
      default: () => "",
    },
    qualification: {
      type: String,
      default: () => "",
    },
    openToNovice: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    precisionsText() {
      return (
        this.precision
          // add newlines on html linebreak
          .replace(/(?:\r\n|\r|\n|\\n|↵|&#8629;)/g, "<br />")
          // prevent double new line on list items
          .replace(/(?:<br \/><br \/>-)/g, "<br />")
      );
    },
    missionAddressDisplay() {
      const { address } = this;
      return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@MISSION_ADDRESS_DISPLAY", { address });
    },
    NovicesPrecision() {
      const { qualification } = this;
      if (this.openToNovice) {
        return this.$t("ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@QUALIFICATION_Novices", {
          qualification,
        });
      }

      return this.$t("ETAB.PAGES.RECRUITMENT.RECAP_MODAL.@QUALIFICATION", { qualification });
    },
  },
};
</script>

<style lang="scss">
.recruitment-recap {
  .recruitment-precisions,
  .recruitement-location,
  .recruitement-number {
    font-size: 0.95em;
    padding: 10px 15px;
  }
}
</style>
